import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

export const usePasswordFrom = (): [InputState, (event: React.SyntheticEvent) => void] => {
  const { t } = useTranslation();
  const [passState, setPassState] = useState<InputState>({
    error: false,
    helperText: t('pleaseEnterPassword'),
    inputValue: '',
    shrink: true,
  });

  const onPassFormChange = (event: React.SyntheticEvent) => {
    const target = event.target as HTMLInputElement;
    if (target.value.length < 6 || target.value.length > 50) {
      setPassState({
        error: true,
        helperText: '* ' + t('passwordLength'),
        inputValue: target.value,
        shrink: target.value !== '',
      });
    } else {
      setPassState({
        error: false,
        helperText: t('passwordLooksGood'),
        inputValue: target.value,
        shrink: target.value !== '',
      });
    }
  };

  return [passState, onPassFormChange];
};

interface InputState {
  inputValue: string;
  error: boolean;
  helperText: string;
  shrink: boolean;
}
